import { EnumLocalStorageKeys } from '_constants'

const store = (storageKey: EnumLocalStorageKeys, data: any) => {
  if (process.env.NEXT_IS_SERVER) {
    return
  }
  window.localStorage.setItem(storageKey, JSON.stringify(data))
}

function retrieve<TReturn>(
  storageKey: EnumLocalStorageKeys
): TReturn | undefined {
  if (process.env.NEXT_IS_SERVER) {
    return
  }
  const data = window.localStorage.getItem(storageKey)

  return data ? JSON.parse(data) : undefined
}

const clear = (storageKey: EnumLocalStorageKeys) => {
  if (process.env.NEXT_IS_SERVER) {
    return
  }
  window.localStorage.removeItem(storageKey)
}

const clearAll = () => window.localStorage.clear()

const localStorage = { store, retrieve, clear, clearAll }
export default localStorage
